/* D/R ARCHIVE phase24: merge legacy dual size labels ("XS / 1", "S / 2"…) into their plain letter size in the
   Size filter (display only). The alias checkbox stays in the form (hidden) and mirrors the plain size, so
   filtering "XS" also returns products whose variant is named "XS / 1". No product data is changed.
   An alias is merged only when its plain size exists in the same filter; otherwise it is shown unchanged. */
(function () {
  var RX = /^(.+?) \/ .+$/;
  function isSize(i) { return /^filter\.v\.option\.size$/i.test(i.name); }
  function countOf(li) { var m = (li && li.textContent || '').match(/\((\d+)\)/); return m ? parseInt(m[1], 10) : 0; }
  function setCount(li, n) {
    var t = li.querySelector('.facet-checkbox__text'); if (!t) return;
    var lab = t.querySelector('.facet-checkbox__text-label');
    if (lab && lab.nextSibling && lab.nextSibling.nodeType === 3) lab.nextSibling.nodeValue = ' (' + n + ')';
  }
  function scan() {
    document.querySelectorAll('form').forEach(function (form) {
      var inputs = [].slice.call(form.querySelectorAll('input[type=checkbox]')).filter(isSize);
      if (!inputs.length) return;
      var byVal = {}; inputs.forEach(function (i) { byVal[i.value] = i; });
      inputs.forEach(function (al) {
        var m = al.value.match(RX); if (!m) return;
        var base = byVal[m[1]]; if (!base || al.dataset.drAliasDone) return;
        al.dataset.drAliasDone = '1';
        var ali = al.closest('li'), bli = base.closest('li');
        if (ali) { ali.style.display = 'none'; ali.setAttribute('aria-hidden', 'true'); }
        base.dataset.drAlias = (base.dataset.drAlias ? base.dataset.drAlias + '|' : '') + al.value;
        if (bli && ali) setCount(bli, countOf(bli) + countOf(ali));
        if (al.checked && !base.checked) base.checked = true;
        if (base.disabled && !al.disabled) { base.disabled = false; if (bli) bli.querySelectorAll('.disabled').forEach(function (e) { e.classList.remove('disabled'); }); }
      });
    });
    /* active filter pills: hide alias pills, and make the plain-size pill remove its alias too */
    document.querySelectorAll('facet-remove a[href]').forEach(function (a) {
      if (a.dataset.drAliasPill) return;
      var u; try { u = new URL(a.href, location.href); } catch (e) { return; }
      var txt = a.textContent.replace(/\s+/g, ' ');
      var all = []; document.querySelectorAll('input[type=checkbox]').forEach(function (i) { if (isSize(i) && i.dataset.drAlias) all.push(i); });
      all.forEach(function (base) {
        base.dataset.drAlias.split('|').forEach(function (alias) {
          if (txt.indexOf(': ' + alias) > -1) { var fr = a.closest('facet-remove'); if (fr) fr.style.display = 'none'; a.dataset.drAliasPill = '1'; }
          else if (new RegExp(':\\s*' + base.value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*$').test(txt.trim().replace(/\s*Remove filter.*$/i, ''))) {
            var p = u.searchParams, keep = p.getAll(base.name).filter(function (v) { return v !== alias; });
            p.delete(base.name); keep.forEach(function (v) { p.append(base.name, v); });
            a.href = u.pathname + '?' + p.toString(); a.dataset.drAliasPill = '1';
          }
        });
      });
    });
  }
  /* mirror the plain size onto its alias before the theme serialises the filter form */
  function sync(e) {
    var t = e.target; if (!t || !t.dataset || !t.dataset.drAlias) return;
    t.dataset.drAlias.split('|').forEach(function (v) {
      var form = t.form || t.closest('form'); if (!form) return;
      form.querySelectorAll('input[type=checkbox]').forEach(function (i) { if (isSize(i) && i.value === v) i.checked = t.checked; });
    });
  }
  document.addEventListener('input', sync, true);
  document.addEventListener('change', sync, true);
  var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(scan, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
